import Languages from '../assets/consts/Languages';

const languageStorageKey = 'language';
const languageStorageArea = window.localStorage;

export const getLanguageStorageKey = () => languageStorageKey;

export const getLanguageStorageArea = () => languageStorageArea;

export const getLanguage = (language) =>
  Object.values(Languages).some((_language) => _language === language) ? language : Languages.greek;

export const fetchLanguage = () => getLanguage(languageStorageArea.getItem(languageStorageKey));

export const storeLanguage = (language) => {
  const newLanguage = getLanguage(language);
  const oldValue = languageStorageArea.getItem(languageStorageKey);
  languageStorageArea.setItem(languageStorageKey, newLanguage);
  window.dispatchEvent(
    new StorageEvent('storage', {
      storageArea: languageStorageArea,
      key: languageStorageKey,
      newValue: newLanguage,
      oldValue: oldValue,
    })
  );
};
